import React, { useEffect } from 'react';
import Spinner from './Spinner';

const FanDelDia = () => {
    const [fanDelDia, setFanDelDia] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        getFanDelDia();
    }, []);
    const getFanDelDia = () => {
        fetch('/api/fanDelDia', {
            method: 'POST'
        })
            .then(response => response.json())
            .then(data => {
                setFanDelDia(data);
                setLoading(false);
            });
    };

    return (
        <div className='fanDelDia homeCard heroes fullCenter'>
            {loading ? <div><Spinner /></div> : (
                fanDelDia ? (
                    <div>
                        <h2 className={fanDelDia.faccion}>El fan del dia es {fanDelDia.displayname} con {fanDelDia.todayFanPoints} puntos de fan.</h2>
                    </div>
                ) : <div>
                    <h2>No hay fan del dia ahora mismo!</h2>
                </div>
            )
            }
        </div >
    )
}

export default FanDelDia;